<script setup>
// "Why retailers choose CLD" trust grid — ported from cld_homepage_mockup_v3 (#22).
const items = [
  { icon: '✓', title: 'why_cld_1_title', text: 'why_cld_1_text' },
  { icon: '⚡', title: 'why_cld_2_title', text: 'why_cld_2_text' },
  { icon: '📦', title: 'why_cld_3_title', text: 'why_cld_3_text' },
  { icon: '🤝', title: 'why_cld_4_title', text: 'why_cld_4_text' },
];
</script>

<template>
  <section class="container mx-auto px-4 mt-2 mb-8">
    <p class="text-xs font-bold uppercase tracking-widest text-[#008556] mb-1">{{ $t('why_cld_kicker') }}</p>
    <h2 class="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">{{ $t('why_cld_title') }}</h2>
    <p class="text-sm text-gray-500 max-w-3xl mb-5">{{ $t('why_cld_desc') }}</p>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <article v-for="item in items" :key="item.title" class="bg-white border border-gray-200 rounded-2xl p-5">
        <div class="trust-icon-chip w-10 h-10 rounded-xl bg-[#e9f6f0] text-[#008556] grid place-items-center text-lg mb-3">
          {{ item.icon }}
        </div>
        <h3 class="text-base font-medium text-gray-900 mb-1.5">{{ $t(item.title) }}</h3>
        <p class="text-xs text-gray-500 m-0">{{ $t(item.text) }}</p>
      </article>
    </div>
  </section>
</template>

<style scoped>
/* Dark-mode chip override lives in assets/css/dark.css (.trust-icon-chip) */
</style>
